import script from "./MyCascader.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyCascader.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__